export default {
  'm': {
    'EnterID': 'Klik untuk memasukkan ID BuzzCast',
    'select-specifications': 'Klik untuk memilih spesifikasi isi ulang',
    'check-account': 'Periksa akun isi ulang',
    'whatID': 'Apanya ID BuzzCast?',
    'getID': 'Masukkan ID BuzzCast',
    'maskgetID': 'Masukkan ID BuzzCast',
    'toastTips-format-error': 'Format dimasukkan salah',
    'toastTips-no-exist': 'ID tidak ada',
    'toastTipsPlease': 'Silakan periksa akun isi ulang terlebih dahulu',
    'common-problem': 'Masalah umum',
    'transaction-succeeded': 'Transaksi berhasil',
    'transaction-failed': 'Transaksi gagal',
    'transaction-cancel': ' Transaksi dibatalkan',
    'whether-account': '1.Bagaimana memeriksa apakah saya telah dikreditkan setelah mengisi ulang?',
    'answer-whether-account': 'Setelah mengisi ulang, Anda dapat kembali ke [Saya] - [Dompet] dalam app untuk melihat berlian',
    'no-account': '2.Bagaimana jika akun saya tidak dikreditkan setelah mengisi ulang?',
    'answer-no-account': 'Silakan kirimkan pertanyaan Anda di [Pesan] - [Berita Resmi] - [Umpan Balik dan Bantuan] dalam app, dan berikan informasi berikut, layanan pelanggan kami akan membantu Anda.',
    'recharge-money': '1. Jumlah dan ID akun isi ulang',
    'recharge-time': '2. Waktu dan tanggal isi ulang',
    'recharge-shot': '3. Tangkapan layar pembayaran yang berhasil',
    'recharge-wrong': '3.Apa harus dilakukan jika saya mengisi akun yang salah atau mengisi jumlah yang salah',
    'answer-recharge-wrong': 'Sebelum memasukkan kata sandi pembayaran, silakan cermat mengkonfirmasi ID akun isi ulang dan informasi jumlah isi ulang sebelum melakukan pembelian. Jumlah isi ulang yang salah tidak dapat dikembalikan. Mengisi ulang ke akaun yang salah, Anda dapat mencoba menghubungi pengguna ID yang benar-benar telah menagih, dan bernegosiasi dengan pihak lain apakah dia bersedia untuk mengkompensasi tagihan Anda.',
    'refund': '4.Pengembalian dana',
    'answer-refund': 'Maaf! BuzzCast saat ini tidak mendukung pengembalian uang berbentuk apa.',
    'buy-enter-link': 'Pembelian berlian dapat diisi ulang melalui tautan, <a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> menyalin tautan di browser ponsel untuk membuka, masuk ke halaman pembelian, setelah memeriksa akun, pilih spesifikasi yang sesuai dan gunakan metode pembayaran yang sesuai untuk membayar ~ Banyak diskon!',
    'buy-notice-a': 'Catata:<a>{msg}</a> adalah satu-satunya situs web pembelian berlian resmi untuk BuzzCast',
    'replace': 'Ubah',
    'sureBtn': 'Tentukan',
    'pay-style': 'Pilih metode pembayaran',
    'goBack': 'Kembali ke beranda',
    'toastTips': 'Masukkan ID BuzzCast',
    'rechargeFAQ_title': 'Masalah umum',
    'PayStatusSuccess_title': 'Transaksi berhasil',
    'PayStatusFail_title': 'Transaksi gagal',
    'PayStatusCancel_title': ' Transaksi dibatalkan',
    'Diamonds_title': 'Situs web isi ulang berlian resmi {msg}',
    'buy-notice': 'Catatan pay.buzzcast.info adalah satu-satunya situs web pembelian berlian resmi dari BuzzCast. Untuk pertanyaan layanan pelanggan, silakan kunjungi [Pesan] - [Berita Resmi] - [Umpan Balik dan Bantuan]',
    'RechargeHelp_title': 'Bantuan isi ulang',
    'openAPP': 'Buka aplikasi BuzzCast',
    'buy-diamonds-tit': 'Beli Layanan berlian',
    'description': 'Satu-satunya web isi ulang berlian resmi BuzzCast. BuzzCast adalah app sosial internasional, pengguna berada di lebih dari 150 negara dan wilayah di seluruh dunia sedang menggunakan BuzzCast',
    'keywords': 'Isi ulang BuzzCast, isi ulang berlian BuzzCast, isi ulang resmi BuzzCast, situs web isi ulang resmi BuzzCast',
    'payforType': 'Metode isi ulang',
    'trueText': 'Tentukan',
    'falseText': 'Batal',
    'alertShowTxt1': 'Apakah Anda yakin menggunakan',
    'alertShowTxt3': 'untuk mengisi ulang berlian',
    'alertShowTxt5': '',
    'EnterIDTip': 'Isi ulang cepat {msg}',
    'scanLogin': 'Untuk privasi dan keamanan akun, harap pindai kode untuk masuk',
    'scanTip': 'Ti: Klik "Pindai" di sudut kanan atas "Pusat Pribadi / Dinamika" BuzzCast untuk memindai kode untuk masuk. Pada saat yang sama, mendukung untuk masuk dengan mengidentifikasi tangkapan layar kode QR',
    'scanVersion': 'Harap tingkatkan BuzzCast ke versi %s dan pindai kode untuk masuk',
    'delAccount': 'Penghapusan akun',
    'logout': 'Keluar',
    'submit': 'Kirim',
    'email_place_holder': 'Masukkan alamat emailmu',
    'contact_email': 'Kontak Email',
    'provide_email': 'Harap berikan alamat email Anda untuk menerima pemberitahuan pembayaran',
    'email_address': 'Alamat email',
    'sel_country_area': 'Pilih negara atau wilayah',
    'search_for': 'Cari pencarian',
    'login': 'Gabung',
    'scan_login': 'Memindai kode login',
    'account_password_error': 'Nomor telepon atau kata sandi salah',
    'user_frozen': 'Pengguna telah ditutup',
    'account_no_reg': 'Akun tidak terdaftar',
    'login_no': 'Anda belum login',
    'login_after_recharge': 'Anda dapat mengisi ulang setelah masuk',
    'scan_login_lesson': 'Tutorial login kode pemindaian',
    'scan_login_desc': 'Metode pemindaian pendaftaran kode dapat dengan cepat dan aman menyadari bahwa Anda mendaftar di situs web isi ulang. Dua metode berikut masing-masing memperkenalkan cara memindai kode untuk login.',
    'scan_login_a_title': 'Masuk dengan mengenali tangkapan layar kode QR',
    'scan_login_a_p1': '1. Ini lebih cocok untuk menggunakan skenario perangkat tunggal. Pengguna memasuki halaman login situs web isi ulang, klik untuk memilih "Pindai kode untuk login", dan ambil screenshot halaman dengan kode QR login ditampilkan, dan simpan album. (Fungsi tangkapan layar sedikit berbeda untuk perangkat yang berbeda, Anda dapat mencari petunjuk pengoperasian fungsi tangkapan layar sendiri)',
    'scan_login_a_p2': '2. Buka Aplikasi BuzzCast, melalui modul fungsi "Pusat Pribadi" atau "Dinamis", klik "Scan" di pojok kanan atas untuk masuk ke modul fungsi pemindaian kode.',
    'scan_login_a_p3': '3. Klik "Pilihan album" dan izinkan izin album, pilih screenshot halaman login kode QR yang disimpan, klik tombol konfirmasi "Login" setelah sistem mengenali, beralih kembali ke browser dan tunggu beberapa saat, halaman akan otomatis memuat pengguna informasi.',
    'scan_login_b_title': 'Masuk dengan memindai kode QR',
    'scan_login_b_p1': '1. Ini lebih cocok untuk penggunaan beberapa perangkat. Pengguna memasuki halaman login situs web isi ulang dan mengklik untuk memilih "Login kode pindai',
    'scan_login_b_p2': '2. Buka Aplikasi BuzzCast di perangkat lain, buka modul fungsi "Pusat Pribadi" atau "Dinamis", dan klik "Scan" di sudut kanan atas untuk masuk ke modul fungsi pemindaian kode.',
    'scan_login_b_p3': '3. Sejajarkan kotak pemindaian kode dengan kode QR pada halaman login pemindaian kode, klik tombol konfirmasi "login" setelah sistem mengenalinya (disarankan untuk menjaga jarak tertentu antara perangkat saat memindai kode, yang lebih mudah untuk dikenali oleh sistem). Setelah beberapa saat, halaman akan memuat informasi pengguna secara otomatis.',
    'scan_login_lesson_end': 'Di atas adalah panduan tutorial untuk memindai kode login, saya berharap dapat membantu Anda. Untuk konsultasi layanan pelanggan, silakan masukkan umpan APP berita-resmi berita-umpan-balik dan bantuan',
    'or': 'Atau',
    'input_phone_num': 'Nomor telepon tidak boleh kosong',
    'input_email': 'Silakan masukkan alamat email Anda',
    'input_password': 'Masukkan kata sandi',
    'log_in_using_Facebook': 'Masuk dengan Facebook',
    'log_in_using_Google': 'Masuk dengan Google',
    'account_or_pwd_error': 'Akun atau kata sandi salah',
    'pay_fail_system_risk': 'Transaksi gagal: sistem tidak normal',
    'friendly_tip': 'Tip hangat',
    'i_got_it': 'Saya mengerti',
    'android_fblogin_tip': 'Karena Facebook tidak lagi mendukung login autentikasi pada browser tertanam Android, Anda mungkin tidak dapat login saat login dengan cara ini. Jika Anda mengalami masalah login seperti ini, gunakan browser Chrome untuk mengaksesnya.',
    'recharge_tip': 'Jumlah berlian tertentu yang telah masuk ke akun tergantung pada jumlah isi ulang yang sebenarnya',
    'charge': 'Isi ulang',
    'link_add_mainpage': 'Tambahkan tautan ke layar beranda untuk memuat ulang berikutnya',
    'click_me_to_add': 'Klik saya untuk menambahkan',
    'user_has_delete': 'Pengguna telah dibatalkan',
    'support_contant_whatsapp': 'Jika Anda memerlukan dukungan, silakan hubungi layanan pelanggan di {msg} App：1924383',
    'buy_balance': 'Saldo yang dapat dibeli:',
    'official_coin_seller': 'Pedagang Koin Resmi',
    'paystyle_unavailabel_change_other': 'Sistem tidak normal, metode pembayaran ini untuk sementara tidak tersedia, Anda dapat mengubah ke metode pembayaran lain.',
    'failedPay': 'Pembayaran menghadapi masalah, silakan membuat pembayaran baru',
    "copied": "Disalin",
    "reseller": "Pengecer",
    "netword_busy_try": "Jaringan sedang sibuk, silakan coba lagi",
    "placecommen": 'Silakan masukkan pencarianmu',
    "app_all_v2": 'Semua',

		"use_phone_login": `Masuk dengan Ponsel`,
    "use_email_login": `Masuk dengan Email`,
    "device_is_more": "Jumlah akun terdaftar untuk perangkat ini telah mencapai batas atas",
    "Operation_failed": "Perangkat ini telah dibekukan secara permanen karena pelanggaran akun",
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/id.js